import React from 'react';
import { CuisineCategory } from 'src/gqlReactTypings.generated.d';
import { useFilterBarState } from 'src/pages/consumer/components/DishFirstHeader/store';
import { MaxWidthContainer } from 'src/pages/consumer/dish-first/explore/components/Segments/styles';
import { PatternedStrip } from 'src/rebrand/Homepage/components/shared/PatternedStrip';
import { WavyEdge } from 'src/shared/design-system/WavyEdge';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

export const HeroContainer = styled.div<{
  hasFilterBar: boolean;
  desktopBackgroundUrl: string;
  mobileBackgroundUrl: string;
}>`
  width: 100%;

  @media (min-width: ${ScreenWidth.EXTRA_LARGE}) {
    width: 1600px;
  }

  margin-right: auto;
  margin-left: auto;

  background: ${Colors.KOHLRABI_LITE_30};

  margin-top: ${({ hasFilterBar }) => (hasFilterBar ? '48px' : '0')};
  padding: ${Spacing.QUADRUPLE} 0 ${Spacing.DOUBLE_HALF} 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  position: relative;

  ${minScreen(ScreenWidth.MEDIUM)} {
    margin-top: 0;
  }
`;

const ContentContainer = styled(MaxWidthContainer)`
  height: fit-content;
  padding: 0 ${Spacing.SINGLE};
  display: flex;
  flex-direction: row;
  gap: ${Spacing.DOUBLE};
  justify-content: flex-start;
  align-items: flex-end;
`;

const Title = styled.h1`
  width: 100%;
  text-align: left;
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.BOLD};
  font-size: ${Font.Size.XL};
  line-height: 120%;
  color: ${Colors.GRAY_DARK_30};

  ${minScreen(ScreenWidth.MEDIUM)} {
    font-size: ${Font.Size.XXXL};
  }
`;

const SubTitle = styled.span`
  width: 100%;
  text-align: left;
  font-family: ${Font.Family.SANS};
  font-weight: ${Font.Weight.SEMI_BOLD};
  font-size: ${Font.Size.XS};
  line-height: 120%;
  color: ${Colors.GRAY_DARK_15};
`;

type IProps = {
  className?: string;
  title: string;
  subtitle?: string | null;
  cuisineCategory: CuisineCategory;
};

export const CollectionHero: React.FC<IProps> = ({ className, title, subtitle, cuisineCategory }) => {
  const filterBarIsShowing = useFilterBarState();

  const content = cuisineCategory.categoryPageContent;

  // Handle cases where we didn't add a sub-cuisine to the configs
  if (!content) return null;

  return (
    <HeroContainer
      className={`justify-end pb-4  pt-16 ${className}`}
      hasFilterBar={filterBarIsShowing}
      desktopBackgroundUrl={content.heroBackgroundUrlDesktop ?? content.heroBackgroundUrl ?? ''}
      mobileBackgroundUrl={content.heroBackgroundUrl ?? ''}>
      <PatternedStrip className='absolute top-0 ' backgroundUrl={content.patternedStripUrl} />
      <ContentContainer>
        <div className='flex grow-0 flex-col'>
          <Title className='mb-4'>{title}</Title>
          {subtitle ? <SubTitle>{subtitle}</SubTitle> : null}
        </div>
      </ContentContainer>
      <WavyEdge waveHeight={8} waveWidth={54} />
    </HeroContainer>
  );
};
